import { DOMAIN } from '../../../../../var_env.'
import { RequestResponsePattern } from '../../../../../types/Request'
import { postApi } from '../../../../../utils/requestApi'

type AddBody = {
    ids: number[]
}

export default async function addMonitoramentoFrequente(ids: number[]): Promise<void> {
    const endpoint = `${DOMAIN}/pessoa-monitoramento-frequente-add`
    const data: AddBody = { ids }

    const response: RequestResponsePattern<any> = await postApi({ endpoint, data })

    if (response) {
        if (!response.flagErro) return
        throw new Error(response.listaMensagens[0])
    }

    throw new Error('Erro na requisição')
}


